// Components
import Home from './routes/Home.svelte';
import Register from './routes/Register.svelte'
import Verify from "./routes/Verify.svelte";
import NotFound from './routes/NotFound.svelte'
import Logout from "./routes/Logout.svelte";
import Login from "./routes/Login.svelte";
import Privacy from "./routes/Privacy.svelte";
import TOS from "./routes/TOS.svelte";

// Export the route definition object
export default {
    '/': Home,
    '/register': Register,
    '/login': Login,
    '/logout': Logout,
    '/verify': Verify,
    '/privacy': Privacy,
    '/tos': TOS,
    '*': NotFound
}
